import Swiper, { Navigation, Pagination } from "swiper";
Swiper.use([Pagination, Navigation]);

const initCooperationSlider = () => {
  const slider = document.querySelector(".cooperation__slider");

  slider && new Swiper(slider, {
      breakpoints: {
         1170: {
         slidesPerGroup: 3,
         slidesPerView: 3,
         spaceBetween: 20,
         },
         767: {
         slidesPerGroup: 2,
         slidesPerView: 2,
         spaceBetween: 15,
         },
         0: {
         slidesPerView: 1,
         spaceBetween: 20,
         },
      },
      navigation: {
         nextEl: ".cooperation .slider-navigation__button--next",
         prevEl: ".cooperation .slider-navigation__button--prev",
      },
      pagination: {
         el: ".cooperation .swiper-pagination",
         type: "fraction",
      },
   });
};

export default initCooperationSlider;
